import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLaptopCode, faServer, faChartBar, faCogs, faTools } from '@fortawesome/free-solid-svg-icons';
import Chip from '@mui/material/Chip';
import { useContent } from '../contexts/ContentContext';
import '../assets/styles/Expertise.scss';

// Icon mapping for FontAwesome icons
const iconMap: { [key: string]: any } = {
  faLaptopCode,
  faServer,
  faChartBar,
  faCogs,
  faTools,
};

function Expertise() {
  const { content } = useContent();
  const skills = content.expertise;

  return (
    <div className="container" id="expertise">
        <div className="skills-container">
            <h1>Expertise</h1>
            <div className="skills-grid">
                {skills.map((skill, index) => (
                    <div key={index} className="skill">
                        <FontAwesomeIcon icon={iconMap[skill.icon] || faLaptopCode} size="3x"/>
                        <h3>{skill.title}</h3>
                        <p>{skill.description}</p>
                        <div className="flex-chips">
                            <span className="chip-title">Tech stack:</span>
                            {skill.techStack.map((tech, techIndex) => (
                                <Chip key={techIndex} className='chip' label={tech} />
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    </div>
  );
}

export default Expertise;